import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Select,
  Button,
  Checkbox,
  Row,
  Col,
  Card,
  Modal,
  Spin
} from 'antd';
import passwordValidator from 'password-validator';
import { NavLink, Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { LoginUser } from '../../actions';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import { CustomAlertModal } from '../../shared';
import { GlobalApiErrorHandler, string_trim } from '../../shared/helpers';
import { AES } from 'crypto-js';
import { SelectBox, InputBox, isBrowser, MsgBox } from '../../shared/custom-ant-d'
import { reqGetDPCSText, reqPostCreateCandidate } from '../../axios/api';

const { Option } = Select;

const schema = new passwordValidator();

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
  },
};

export const Register = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const LookUpData = useSelector(state => state.LookUpData);

  const [registerLoading, setRegisterLoading] = useState(false);
  const [countries, setCountries] = useState(null);
  const [countriesLoading, setCountriesLoading] = useState(true);
  const [countryIdSelected, setCountryIdSelected] = useState("");

  const [termContent, setTermContent] = useState("");
  const [termsReachBottom, setTermsReachBottom] = useState(false);
  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
  const [hasAccepttedTerms, setHasAcceptedTerms] = useState(false);
  const [isInfoModalVisible, setIsInfoModalVisible] = useState(false);

  const [isEllipsed, setIsEllipsed] = useState(true);

  useEffect(() => {
    if (LookUpData !== null) {
      getCountryList();
    }
  }, [LookUpData]);

  const getCountryList = () => {
    setCountries(LookUpData.countryList);
    setCountriesLoading(false);
  }

  const getTerms = (countryId) => {
    reqGetDPCSText(countryId)
      .then(res => {
        setTermContent(res.data);
      })
      .catch(err => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }

  const onFinish = (values) => {
    setRegisterLoading(true);
    // §11.3: send the plaintext password over TLS; Careers.Web encrypts it server-side.
    submit(values, values.password);
  };

  const submit = (values, plainPass) => {
    setRegisterLoading(true);
    var jsonData = {
      FirstName: string_trim(values.firstname),
      LastName: string_trim(values.lastname),
      PersonalEmail: string_trim(values.email),
      Password: plainPass,
      CountryID: string_trim(values.country),
    };

    var jsonStr = JSON.stringify(jsonData);

    reqPostCreateCandidate(jsonStr)
      .then(res => {
        if (res.data.isSuccess) {
          MsgBox({
            type: 'success',
            message: 'Successfully Registered',
            description: "Welcome to your new account."
          });

          let candidate = res.data.candidateObj;

          const envrypted = AES.encrypt(JSON.stringify(candidate), 'IQORCAREERS').toString();
          sessionStorage.setItem("candidate", envrypted);

          dispatch(LoginUser({
            candidateID: candidate.candidateID,
            personalEmail: candidate.personalEmail,
            firstName: candidate.firstName,
            middleName: candidate.middleName,
            lastName: candidate.lastName,
            currentTitle: "",
            currentCompany: "",
            primaryPhone: candidate.primaryPhone,
            secondaryPhone: candidate.secondaryPhone,
            preferedContactMethodID: candidate.preferedContactMethodID,
            homeAddress1: candidate.homeAddress1,
            homeAddress2: candidate.homeAddress2,
            homeAddress3: candidate.homeAddress3,
            city: candidate.city,
            province: "",
            stateID: candidate.stateID,
            zipCode: candidate.zipCode,
            countryID: candidate.countryID,
            countryName: candidate.countryName,
            candidateCoverLetterUniqueID: candidate.candidateCoverLetterUniqueID,
            candidateResumeUniqueID: candidate.candidateResumeUniqueID,
            candidateCoverLetterFileFriendlyName: candidate.candidateCoverLetterFileFriendlyName,
            candidateResumeFileFriendlyName: candidate.candidateResumeFileFriendlyName,
            candidateBirthCertificateUniqueID: candidate.candidateBirthCertUniqueID,
            candidateBirtCertificateFriendlyName: candidate.candidateBirthCertFileFriendlyName,
            candidateCXCUniqueID: candidate.candidateCXCUniqueID,
            candidateCXCFriendlyName: candidate.candidateCXCFileFriendlyName,
            highestLevelOfEducationID: candidate.highestLevelOfEducationID
          }));

          if (history.location.state !== undefined) {
            if (history.location.state.prevPath !== undefined) {
              let pushLink = {
                pathname: history.location.state.prevPath,
                state: history.location.state
              };

              if (history.location.state.search !== undefined && history.location.state.search) {
                pushLink.search = history.location.state.search
              }

              return history.push(pushLink);
            }
          } else {
            return history.push('/profile');
          }
        } else {
          MsgBox({
            type: 'error',
            message: 'Registration failed',
            description: res.data.errorMessage,
          });
        }
        setRegisterLoading(false);
      })
      .catch(err => {
        console.log(err);
        setRegisterLoading(false);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }

  const handleEllipse = e => {
    const el = e.target.closest(".click-show-all");
    if (el && e.currentTarget.contains(el)) {
      setIsEllipsed(false);
    }
  }

  const showModal = (e) => {
    e.preventDefault();

    if (countryIdSelected) {
      setIsTermsModalVisible(true);
    } else {
      setIsInfoModalVisible(true);
    }
  };

  const handleOk = (e) => {
    e.preventDefault();
    setIsTermsModalVisible(false);
    setHasAcceptedTerms(true);
    form.setFieldsValue({
      terms_of_use: true
    });
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setIsTermsModalVisible(false);
    setTermContent("");
    setCountryIdSelected(0);
    form.resetFields();
  };

  const handleCloseModal = (e) => {
    e.preventDefault();
    setIsTermsModalVisible(false);
  };

  const handleChangeCountry = (value) => {
    setCountryIdSelected(value);
    getTerms(value);
    setTermsReachBottom(false);
    setHasAcceptedTerms(false);
    setIsEllipsed(true);
    form.setFieldsValue({
      terms_of_use: false
    });
  }

  const handlePrint = () => {
    var content = document.getElementById("terms-content");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  const termsScrollCheck = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      setTermsReachBottom(true);
    }
  }
  return (
    <>
      <Row className="margin-to-nav">
        <Col sm={{ span: 20, offset: 2 }} xs={24}>
          <Card title="Career Opportunities: Create an Account" className="iqor-header">
            <Form
              {...layout}
              name="nest-messages"
              className="label-left-align"
              onFinish={onFinish}
              validateMessages={validateMessages}
              form={form}
            >
              <Row>
                <Col>
                  <p>
                    Already a registered user? {" "}
                    <NavLink tag={Link} className="" to="/login">
                      Please sign in
                    </NavLink>
                  </p>
                </Col>
              </Row>
              <Form.Item
                name="email"
                label="Email Address"
                hasFeedback
                rules={[
                  {
                    type: 'email',
                    required: true,
                  },
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox type={'email'} />)
                }
              </Form.Item>
              <Form.Item
                name="confirm-email"
                label="Confirm Email Address"
                hasFeedback
                rules={[
                  {
                    required: true,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('email').toLowerCase() === value.toLowerCase()) {
                        return Promise.resolve();
                      }

                      return Promise.reject('The two email that you entered do not match!');
                    },
                  })
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox type={'email'} />)
                }
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                hasFeedback
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      schema
                        .is().min(8);
                      if (!schema.validate(value, { list: true }).includes('min')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password needs to be at least 8 characters long.')
                      }
                    }
                  }),
                  () => ({
                    validator(_, value) {
                      schema
                        .is().max(20);
                      if (!schema.validate(value, { list: true }).includes('max')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password must not be longer than 20 characters.')
                      }
                    }
                  }),
                  () => ({
                    validator(_, value) {
                      schema
                        .has().uppercase();

                      if (!schema.validate(value, { list: true }).includes('uppercase')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password needs at least 1 uppercase character.')
                      }
                    }
                  }),
                  () => ({
                    validator(_, value) {
                      schema
                        .has().digits(2);

                      if (!schema.validate(value, { list: true }).includes('digits')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password needs at least 2 numerical characters.')
                      }
                    }
                  }),
                  () => ({
                    validator(_, value) {
                      schema
                        .has().symbols();

                      if (!schema.validate(value, { list: true }).includes('symbols')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password needs at least 1 special character.')
                      }
                    }
                  }), () => ({
                    validator(_, value) {
                      schema
                        .has().not().spaces();

                      if (!schema.validate(value, { list: true }).includes('spaces')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password should not have spaces.')
                      }
                    }
                  }), () => ({
                    validator(_, value) {
                      schema
                        .has().lowercase();

                      if (!schema.validate(value, { list: true }).includes('lowercase')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Password needs at least 1 lowercase character.')
                      }
                    }
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input.Password />) :
                    (<InputBox type={'password'} />)
                }
              </Form.Item>

              <Form.Item
                name="confirm"
                label="Confirm Password"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject('The two passwords that you entered do not match!');
                    },
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input.Password />) :
                    (<InputBox type={'password'} />)
                }
              </Form.Item>

              <Form.Item
                name="firstname"
                label="Legal First Name"
                hasFeedback
                rules={[
                  {
                    required: true,
                  },
                  {
                    max: 50,
                    message: 'First name cannot be longer than 50 characters'
                  }
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox />)
                }
              </Form.Item>

              <Form.Item
                name="lastname"
                label="Legal Last Name"
                hasFeedback
                rules={[
                  {
                    required: true,
                  },
                  {
                    max: 50,
                    message: 'Lirst name cannot be longer than 50 characters'
                  }
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox />)
                }
              </Form.Item>

              <Form.Item
                name="country"
                label="Country/Region of Residence"
                hasFeedback
                rules={[
                  {
                    required: true,
                  }
                ]}
              >
                <SelectBox
                  data={
                    countries && (
                      countries.map((item, i) => {
                        return ({ value: item.countryID, label: item.countryName })
                      })
                    )
                  }
                  label={''}
                  onChange={(value) => {
                    //props.form.setFieldsValue({ countryId: value })
                    handleChangeCountry(value)
                  }}
                  onDismiss={(value) => {
                    props.form.setFieldsValue({ countryId: value })
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={countriesLoading ? <Spin size="small" /> : null}
                />

                {/* <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={handleChangeCountry}
                  notFoundContent={countriesLoading ? <Spin size="small" /> : null}
                >
                  {
                    countries && (
                      countries.map((item, i) => {
                        return (
                          <Option value={item.countryID} key={i}>{item.countryName}</Option>
                        );
                      })
                    )
                  }
                </Select> */}
              </Form.Item>

              <Form.Item
                name="terms_of_use"
                label="Terms of Use"
                className="hide-checkbox"
                valuePropName="checked"
                initialValue={hasAccepttedTerms}
                value={hasAccepttedTerms}
                required
                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject('You must accept the terms of the data privacy statement to proceed.'),
                  },
                ]}
              >
                <Checkbox checked={hasAccepttedTerms}>
                  <a href="/" onClick={(e) => { showModal(e) }}>Read and accept the data privacy statement.</a>
                </Checkbox>

              </Form.Item>

              <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                <Button type="danger" htmlType="submit" loading={registerLoading}>
                  Create Account
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>

      <Modal
        title='Data Privacy Consent Statement (Click on "Show All" to read the full agreement)'
        visible={isTermsModalVisible}
        onCancel={handleCloseModal}
        className="terms-modal"
        destroyOnClose
        width={850}
        footer={[
          <Button
            key="print"
            style={{ float: "left" }}
            disabled={termContent === ""}
            onClick={handlePrint}
          >
            Print
          </Button>,
          <Button
            key="decline"
            disabled={termContent === "" || isEllipsed}
            onClick={e => handleCancel(e)}
            type="danger"
          >
            Decline
          </Button>,

          <Button
            key="accept"
            disabled={termContent === "" || isEllipsed}
            onClick={e => handleOk(e)}
            type="danger"
          >
            Accept
          </Button>
        ]}
      >

        <div id="terms-content" className={!isEllipsed ? "maximize" : ""} onScroll={e => termsScrollCheck(e)} key={0}>

          {
            isEllipsed ? (
              <>
                <div onClick={handleEllipse}>
                  <HTMLEllipsis
                    unsafeHTML={termContent}
                    maxLine={7}
                    ellipsisHTML={`...<span class='badge badge-info ellipsis-btn click-show-all'>Show All</span>`}
                    basedOn='words' />
                </div>
              </>
            ) : (
              <>
                <div>{termContent ? <div dangerouslySetInnerHTML={{ __html: termContent }}></div> : <Spin />}</div>
              </>
            )
          }

        </div>
        <iframe id="ifmcontentstoprint" style={{ height: "0px", width: "0px", position: "absolute", display: "none" }}></iframe>
      </Modal>

      <CustomAlertModal
        type="info"
        content="Please select a Country/Region of Residence."
        onCancel={() => { setIsInfoModalVisible(false) }}
        visible={isInfoModalVisible}
        footer={[
          <Button
            key='ok'
            onClick={() => { setIsInfoModalVisible(false) }}
            type="danger"
          >
            OK
          </Button>
        ]}
      />
    </>
  );
}
